import apiClient from "@/app/api/client";
import type { PaginatedApiResponse } from "@/shared/types/pagination";
import type { RetentionRun, RetentionStatus } from "../types";

interface SingleRunResponse {
	success: true;
	data: RetentionRun;
}

/**
 * ⚠️ `GET /retention/runs` **sahifalangan** (`paginated()`), `positions`
 * dagi yalang'och massiv EMAS — javob `data.items` + `data.meta`.
 * Ro'yxat `usePaginatedQuery` orqali olinadi, bu servis esa faqat
 * bitta yugurish va mutatsiyalar uchun.
 */
export const retentionApi = {
	async list(params: {
		status?: RetentionStatus;
		limit?: number;
	}): Promise<{ items: RetentionRun[]; total: number }> {
		const response = await apiClient.get<PaginatedApiResponse<RetentionRun>>("/retention/runs", {
			params,
		});

		return { items: response.data.data.items, total: response.data.data.meta.total };
	},

	/**
	 * ⚠️ **Hozircha iste'molchisi YO'Q va bu ataylab.** `GET
	 * /retention/runs/{id}` — kontrakt §6.4 MAJBURIY qilgan marshrut;
	 * sahifa ochiq yugurishlarni ro'yxatdan to'liq oladi, ya'ni bitta
	 * yugurishni alohida so'rash kerak emas. Mijoz tarafi marshrut
	 * bilan birga saqlanadi — o'chirilsa keyingi iste'molchi (tafsilot
	 * oynasi, chuqur havola) uni qaytadan yozardi.
	 */
	async get(id: string): Promise<RetentionRun> {
		const response = await apiClient.get<SingleRunResponse>(`/retention/runs/${id}`);
		return response.data.data;
	},

	/**
	 * ⚠️⚠️ **QAYTARIB BO'LMAYDIGAN AMAL.** `reason` MAJBURIY va server
	 * uni `.trim().min(5)` bilan tekshiradi — modal ham AYNAN shu
	 * chegarani qo'llasin, aks holda foydalanuvchi 422 ni tugmani
	 * bosgandan KEYIN ko'radi.
	 */
	async confirm(id: string, reason: string): Promise<RetentionRun> {
		const response = await apiClient.post<SingleRunResponse>(`/retention/runs/${id}/confirm`, {
			reason,
		});
		return response.data.data;
	},

	async cancel(id: string, reason: string): Promise<RetentionRun> {
		const response = await apiClient.post<SingleRunResponse>(`/retention/runs/${id}/cancel`, {
			reason,
		});
		return response.data.data;
	},
};
